import React, { useEffect, useState } from "react";
import { Modal, Select, Form, Button, Input } from "antd";
const { Option } = Select;

const RiderReAssignModal = (props) => {
  const [currentRider, setCurrentRider] = useState(props.riderId);

  const options = [];
  if (props.zoneRiders.length > 0) {
    props.zoneRiders.map((v, i) => {
      // console.log("i ", v);
      options.push({
        label: v.display_id + " - " + v.fullName + " " + v.phoneNumber,
        value: v.id,
        disabled: props.riderId === v.id ? true : false,
      });
    });
  }


  function onSearch(val) {
    // console.log("search:", val);
  }

  const [form] = Form.useForm();

  return (
    <Modal
      title="Rider Re-assign"
      visible={props.riderReAssignModal}
      onCancel={props.handleCancel}
      footer={[
        <Button key="back" onClick={props.handleCancel}>
          Cancel
        </Button>,
        <Button form="myForm" key="submit" htmlType="submit">
          Submit
        </Button>,
      ]}
      style={{
        top: 20,
      }}
    >
      <Form
        form={form}
        id="myForm"
        layout="vertical"
        onFinish={props.onFinish}
        initialValues={{ riderRemoveId: props.riderId }}
      >
        <Form.Item name="riderRemoveId" hidden={true}>
          <Input type="text" disabled value={props.riderId} />
        </Form.Item>
        <Form.Item defaultValue={props.riderName} label="Current Rider">
          <Input type="text" disabled value={props.riderName} />
        </Form.Item>
        <Form.Item
          name={"riderId"}
          rules={[{ required: true, message: "Please select rider" }]}
          label="Assign to"
        >
          <Select
            // mode="multiple"
            showSearch
            allowClear
            style={{
              width: "100%",
            }}
            placeholder="Please select"
            // onChange={handleChange}
            // options={options}
            onSearch={onSearch}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0 ||
              option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {options.map((p) => (
              <Option value={p.value}>{p.label}</Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RiderReAssignModal;
